import React, { useEffect, useLayoutEffect } from 'react';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AboutScreen } from '../components/About/AboutScreen';
import { SummaryScreen } from '../components/Summary/SummaryScreen';
import { ProjectScreen } from '../components/Project/ProjectScreen';
import Menu from '../common/Menu';
import { Footer } from '../common/Footer/Footer';
import { analytics, logPageView } from '../utils/analytics';
import { PrivacyScreen } from '../components/Privacy/PrivacyScreen';
import { profile } from '../common/content';

const metadata = {
  '/': { title: 'Ray Saracual Carrera | Tech Lead y desarrollador senior', description: 'Modernización de sistemas, desarrollo de producto y liderazgo técnico. Conoce la trayectoria, proyectos y soluciones de Ray Saracual Carrera.' },
  '/projects': { title: 'Proyectos y decisiones | Ray Saracual Carrera', description: 'Casos de modernización, integración y desarrollo de producto. Aportaciones técnicas y proyectos propios de AxiomFlow.' },
  '/summary': { title: 'Experiencia y CV | Ray Saracual Carrera', description: 'Trayectoria en Plataforma Group, consultoría de CONFIHOG, experiencia técnica y CV actualizado de Ray Saracual Carrera.' },
  '/privacy': { title: 'Privacidad | Ray Saracual Carrera', description: 'Contacto profesional, privacidad y control de estadísticas opcionales del portafolio.' },
};

function updateMeta(attribute, name, content) {
  let element = document.head.querySelector(`meta[${attribute}="${name}"]`);
  if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, name); document.head.appendChild(element); }
  element.setAttribute('content', content);
}

export const AppRoutes = () => {

  const location = useLocation();
  useEffect(() => {
    if (location.pathname === '/about') return;
    const page = metadata[location.pathname] || { title: 'Página no encontrada | Ray Saracual Carrera', description: 'La página solicitada no está disponible.' };
    document.title = page.title;
    updateMeta('name', 'description', page.description);
    updateMeta('name', 'title', page.title);
    updateMeta('name', 'robots', metadata[location.pathname] ? 'index, follow' : 'noindex, follow');
    updateMeta('property', 'og:title', page.title);
    updateMeta('property', 'og:description', page.description);
    updateMeta('property', 'og:url', new URL(location.pathname, profile.siteUrl).href);
    updateMeta('property', 'twitter:title', page.title);
    updateMeta('property', 'twitter:description', page.description);
    updateMeta('property', 'twitter:url', new URL(location.pathname, profile.siteUrl).href);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = new URL(location.pathname, profile.siteUrl).href;
    logPageView(location.pathname, page.title);
  }, [location.pathname]);

  useEffect(() => {
    const startedAt = Date.now();
    const reached = new Set();
    const thresholds = [25, 50, 75, 100];
    const onScroll = () => {
      const total = document.documentElement.scrollHeight;
      if (total <= 0) return;
      const depth = Math.min(100, Math.round(((window.scrollY + window.innerHeight) / total) * 100));
      for (const threshold of thresholds) {
        if (depth >= threshold && !reached.has(threshold)) { reached.add(threshold); analytics.trackScrollDepth(threshold); }
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      analytics.trackTimeOnPage(location.pathname, (Date.now() - startedAt) / 1000);
    };
  }, [location.pathname]);

  useLayoutEffect(() => {
    if (location.hash) document.getElementById(decodeURIComponent(location.hash.slice(1)))?.scrollIntoView({ behavior: 'instant' });
    else window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname, location.hash]);

  return (
      <div className='app__main'>
      <Menu />
        <main id="contenido" className='app__page'>
          <Routes>
                <Route path="/" element={<AboutScreen/>}/>
                <Route path="/about" element={<Navigate to="/" replace />}/>
                <Route path="/summary" element={<SummaryScreen/>}/>
                <Route path="/projects" element={<ProjectScreen/>}/>
                <Route path="/privacy" element={<PrivacyScreen/>}/>
                <Route path="*" element={<section className="container page-intro"><h1>Página no encontrada.</h1><p>El enlace no corresponde a una página del portafolio.</p><Link to="/" className="text-link">Volver al inicio</Link></section>} />
          </Routes>
        </main>
          <Footer />
      </div>
  )
}
